import React, { memo } from "react";

const DocumentIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="currentColor"
    >
      <path
        d="M7.74355 19.2089H17.2827V17.6219H7.74355V19.2089ZM7.74355 14.0024H17.2827V12.4154H7.74355V14.0024ZM4.98394 24.0996C4.43877 24.0996 3.97182 23.906 3.58309 23.5189C3.19436 23.1318 3 22.6668 3 22.1239V2.07532C3 1.53241 3.19436 1.0674 3.58309 0.680285C3.97182 0.293168 4.43877 0.0996094 4.98394 0.0996094H15.6891L22.0263 6.41049V22.1239C22.0263 22.6668 21.8319 23.1318 21.4432 23.5189C21.0545 23.906 20.5875 24.0996 20.0423 24.0996H4.98394ZM14.8923 7.15705H20.4327L14.8923 1.68661V7.15705Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { DocumentIcon };
